"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

const formatDate = (value) => {
  if (!value) return "";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export default function Menu() {
  const pathname = usePathname();
  const [latestArticles, setLatestArticles] = useState([]);
  const [isLoadingArticles, setIsLoadingArticles] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchLatestArticles = async () => {
      try {
        const response = await fetch("/api/articles/latest?limit=3", {
          cache: "no-store",
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch latest articles: ${response.status}`);
        }

        const data = await response.json();
        if (isMounted) {
          setLatestArticles(Array.isArray(data.articles) ? data.articles : []);
        }
      } catch (error) {
        console.error("Error loading latest articles", error);
        if (isMounted) {
          setLatestArticles([]);
        }
      } finally {
        if (isMounted) {
          setIsLoadingArticles(false);
        }
      }
    };

    fetchLatestArticles();

    return () => {
      isMounted = false;
    };
  }, []);

  const checkCurrentMenuItem = (path) =>
    pathname === path ? "current-item" : "";
  const checkParentActive = (paths) =>
    paths.some((path) => pathname.startsWith(path)) ? "current-menu-item" : "";

  return (
    <>
      <ul className="navigation">
        {/* <li
          className={`has-child relative ${checkParentActive(["/home-02", "/home-03", "/home-04", "/home-silde-text-scroll"])}`}
        >
          <Link href="/#">Home</Link>
          <ul className="sub-menu">
            <li className={checkCurrentMenuItem("/")}>
              <Link href="/">Homepage 01</Link>
            </li>
            <li className={checkCurrentMenuItem("/home-02")}>
              <Link href="/home-02">Homepage 02</Link>
            </li>
            <li className={checkCurrentMenuItem("/home-03")}>
              <Link href="/home-03">Homepage 03</Link>
            </li>
            <li className={checkCurrentMenuItem("/home-04")}>
              <Link href="/home-04">Homepage 04</Link>
            </li>
            <li className={checkCurrentMenuItem("/home-silde-text-scroll")}>
              <Link href="/home-silde-text-scroll">Home Slide Text Scroll</Link>
            </li>
          </ul>
        </li> */}

        <li className={`item ${pathname === "/" ? "current-menu-item" : ""}`}>
          <Link href="/">Home</Link>
        </li>

        <li
          className={`item ${pathname === "/about-us" ? "current-menu-item" : ""}`}
        >
          <Link href="/about-us">About Us</Link>
        </li>

        <li
          className={`has-child  ${checkParentActive(["/earwax-removal/microsuction", "/earwax-removal/water-irrigation", "/earwax-removal/ear-health-assessment", "/earwax-removal/pre-hearing-aid-wax-removal", "/earwax-removal/home-visit-earwax-removal-bristol", "/earwax-removal/childrens-earwax-removal-bristol"])}`}
        >
          <Link href="/earwax-removal">Earwax Removal</Link>
          <div className="sub-menu service-link">
            <div className="tf-container">
              <div className="row">
                <div className="col-12">
                  <div className="wrap-cta">
                    <div className="left">
                      <h5 className="wg-title">Earwax Removal Services</h5>
                      <div className="wrap-service">
                        <div className="service-item-list">
                          <Link href="/earwax-removal/microsuction">
                            <h6>Microsuction</h6>
                            <p className="text-2">
                              Safe, precise earwax removal using gentle suction
                              under direct vision.
                            </p>
                          </Link>
                        </div>
                        <div className="service-item-list">
                          <Link href="/earwax-removal/water-irrigation">
                            <h6>Watter Irrigation</h6>
                            <p className="text-2">
                              A gentle warm water rinse to clear softened earwax
                              effectively.
                            </p>
                          </Link>
                        </div>
                        <div className="service-item-list">
                          <Link href="/earwax-removal/home-visit-earwax-removal-bristol">
                            <h6>Home Visit Appointments</h6>
                            <p className="text-2">
                              Professional earwax removal delivered in the
                              comfort of your home.
                            </p>
                          </Link>
                        </div>
                        <div className="service-item-list">
                          <Link href="/earwax-removal/clinic-earwax-removal-bristol">
                            <h6>Clinic Appointments</h6>
                            <p className="text-2">
                              Visit our Bristol clinic for expert earwax removal
                              services.
                            </p>
                          </Link>
                        </div>
                        <div className="service-item-list">
                          <Link href="/earwax-removal/ear-health-assessment">
                            <h6>Ear Health Assessment</h6>
                            <p className="text-2">
                              Detailed examination of your ear canal and eardrum
                              using a video otoscope.
                            </p>
                          </Link>
                        </div>
                        <div className="service-item-list">
                          <Link href="/earwax-removal/pre-hearing-aid-wax-removal">
                            <h6>Pre-Hearing Aid Wax Removal</h6>
                            <p className="text-2">
                              Essential ear cleaning to ensure accurate hearing
                              aid fittings and performance.
                            </p>
                          </Link>
                        </div>

                        <div className="service-item-list">
                          <Link href="/earwax-removal/childrens-earwax-removal-bristol">
                            <h6>Children’s Earwax Removal</h6>
                            <p className="text-2">
                              Gentle, safe earwax removal for young people aged
                              16 and over.
                            </p>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="right">
                      <h5 className="wg-title">What’s New</h5>
                      <div className="wrap-list">
                        {latestArticles.length ? (
                          latestArticles.map((article) => {
                            const formattedDate = formatDate(
                              article.publishDate
                            );

                            return (
                              <div className="box-listings" key={article.id}>
                                <div className="image-wrap">
                                  {article.featuredImage?.url ? (
                                    <img
                                      src={article.featuredImage.url}
                                      alt={
                                        article.featuredImage.alt ||
                                        article.title
                                      }
                                    />
                                  ) : (
                                    <div className="aspect-[4/3] w-full bg-gray-100" />
                                  )}
                                </div>
                                <div className="content">
                                  {formattedDate && (
                                    <ul className="meta">
                                      <li className="text-2">
                                        {formattedDate}
                                      </li>
                                    </ul>
                                  )}
                                  <div className="title text-1 fw-5 line-clamp-2">
                                    <Link
                                      href={`/blog/${article.uid}`}
                                      className="line-clamp-2"
                                    >
                                      {article.title}
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <p className="text-2">
                            {isLoadingArticles
                              ? "Loading latest articles..."
                              : "No articles available yet."}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>

        {/* <li
          className={`has-child relative ${checkParentActive(["/blog-grid", "/blog-details", "/blog-details-2"])}`}
        >
          <Link href="/#">Blogs</Link>
          <ul className="sub-menu">
            <li className={checkCurrentMenuItem("/blog-grid")}>
              <Link href="/blog-grid">Blog Grid</Link>
            </li>
            <li className={checkCurrentMenuItem("/blog-details")}>
              <Link href="/blog-details">Blog Details 1</Link>
            </li>
            <li className={checkCurrentMenuItem("/blog-details-2")}>
              <Link href="/blog-details-2">Blog Details 2</Link>
            </li>
          </ul>
        </li> */}
        {/* <li className={checkCurrentMenuItem("/contact-us")}> */}
        <li
          className={`item ${pathname === "/blog" ? "current-menu-item" : ""}`}
        >
          <Link href="/blog">Blog</Link>
        </li>
        <li
          className={`item ${pathname === "/contact-us" ? "current-menu-item" : ""}`}
        >
          <Link href="/contact-us">Contact</Link>
        </li>
      </ul>
    </>
  );
}
